.schema-select-widget {
  line-height: 1.3rem;
}

.rjsf .form-group.field .extra-text {
  padding-bottom: 0.5rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvSnNvbkVkaXRvci93aWRnZXRzIiwic291cmNlcyI6WyJTZWxlY3RXaWRnZXQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFOzs7QUFHRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLnNjaGVtYS1zZWxlY3Qtd2lkZ2V0IHtcbiAgbGluZS1oZWlnaHQ6IDEuM3JlbTtcbn1cblxuLnJqc2YgLmZvcm0tZ3JvdXAuZmllbGQgLmV4dHJhLXRleHQge1xuICBwYWRkaW5nLWJvdHRvbTogMC41cmVtO1xufVxuIl19 */